import { ISearchFilterDefinition } from '@shared/types/search';

import { STYLE_FILTER_KEY } from '~/constants';

export enum Dropdown {
  Account = 'DropdownAccount',
  Garage = 'DropdownGarage',
}

export enum Modal {
  Account = 'ModalAccount',
  Logout = 'ModalLogout',
}

export enum CartMetafieldKeys {
  'BUNDLE_SELECTED_VARIANTS' = '__bundleSelectedVariants',
}

export enum VehicleSidebarState {
  CLOSED,
  MANUAL_SEARCH,
  MANUAL_SEARCH_RESULTS,
  VIN_SEARCH,
  REGO_SEARCH,
  GARAGE,
}

export const QUICK_ORDER_LOCAL_STORAGE = 'quick-order';

export const SEARCH_FILTER_VARIANT_OPTION_PREFIX = 'variant_options';
export const SEARCH_FILTER_PRODUCT_OPTION_PREFIX = 'option';

export const STYLE_QUERY_PARAM = 'style';
export const VEHICLE_QUERY_PARAM = 'vehicle';
export const CATEGORY_QUERY_PARAM = 'category';
//
export const CATEGORIES_QUERY_PARAM = 'categories';
export const SEARCH_PRICE_FILTER_KEY = 'price';
export const PROMOTION_QUERY_PARAM = 'promotion';
export const AVAILABILITY_QUERY_PARAM = 'availability';
export const QUANTITY_FILTER_KEY = 'inventory_quantity';
export const SEARCH_CATEGORY_FILTER = 'collection_titles';
export const SEARCH_FILTER_TITLE_PREFIX = 'count.';
export const SEARCH_FILTERS_DEFINITIONS: ISearchFilterDefinition[] = [
  {
    filterKey: SEARCH_CATEGORY_FILTER,
    queryParameterName: CATEGORY_QUERY_PARAM,
    label: 'Promotions',
  },
  {
    filterKey: 'product_type',
    queryParameterName: 'product_type',
  },
  {
    filterKey: `options_size`,
    queryParameterName: 'size',
  },
  {
    filterKey: `options_colour`,
    queryParameterName: 'colour',
  },
  {
    filterKey: SEARCH_PRICE_FILTER_KEY,
    queryParameterName: 'price',
  },
  {
    filterKey: QUANTITY_FILTER_KEY,
    queryParameterName: AVAILABILITY_QUERY_PARAM,
    label: 'Availability',
  },
  {
    filterKey: 'vendor',
    queryParameterName: 'vendor',
    label: 'Brand',
  },
  {
    filterKey: STYLE_FILTER_KEY,
    queryParameterName: 'style',
    label: 'Style',
  },
  {
    filterKey: 'tags',
    queryParameterName: 'on_sale',
    label: 'On Sale',
  },
];

export const FILTER = {
  AVAILABILITY: {
    OPTIONS: [
      {
        value: 'in-stock',
        label: 'In Stock',
      },
      {
        value: 'out-of-stock',
        label: 'Out of Stock',
      },
      {
        value: 'made-to-order',
        label: 'Made to Order',
      },
    ],
  },
};

export const SEARCH_PRICE_RANGES = [
  {
    minPrice: 0,
    maxPrice: 50,
  },
  {
    minPrice: 50,
    maxPrice: 100,
  },
  {
    minPrice: 100,
    maxPrice: 500,
  },
  {
    minPrice: 500,
    maxPrice: 1000,
  },
  {
    minPrice: 1000,
    maxPrice: 3000,
  },
  {
    minPrice: 3000,
    maxPrice: 7500,
  },
];
